import {
  FETCH_LIKES_ERROR,
  FETCH_LIKES_PENDING,
  FETCH_LIKES_SUCCESS,
} from "../actions/likes";

const initialState = {
  pending: false,
  data: null,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_LIKES_PENDING:
      return {
        ...state,
        likePending: true,
      };
    case FETCH_LIKES_SUCCESS:
      return {
        ...state,
        likePending: false,
        data: action.payload,
      };
    case FETCH_LIKES_ERROR:
      return {
        ...state,
        likePending: false,
        error: action.error,
      };
    default:
      return state;
  }
}
